import React, { createContext, useContext, useEffect, useState } from 'react';
import { getUserProfile } from '../api/userProfileApi';
import { ADMIN_PERSONA_TYPES } from '../constants/rbac';

const TicketingUserContext = createContext(null);

export function TicketingUserProvider({ children }) {
  const [personaType, setPersonaType] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getUserProfile()
      .then((dto) => {
        setPersonaType(dto.personaType ?? null);
        setOrgId(dto.org?.id ?? dto.orgId ?? null);
      })
      .catch(() => {
        setPersonaType(null);
        setOrgId(null);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const isAdmin = Boolean(personaType && ADMIN_PERSONA_TYPES.includes(personaType));

  const value = {
    personaType,
    orgId,
    isAdmin,
    isLoading,
  };

  return (
    <TicketingUserContext.Provider value={value}>
      {children}
    </TicketingUserContext.Provider>
  );
}

export function useTicketingUser() {
  const ctx = useContext(TicketingUserContext);
  if (!ctx) {
    return {
      personaType: null,
      orgId: null,
      isAdmin: false,
      isLoading: false,
    };
  }
  return ctx;
}
